export default __webpack_public_path__ + "static/media/0x2db0db271a10661e7090b6758350e18f6798a49d.61ec7f0e.webp";